import React, { useState, useRef, useEffect } from 'react';
// Импортируем стили для мобильного Telegram-стиля
import './MiniAppMain.css';

const GIFTS_25 = [
  { type: 'lollipop', label: 'Леденец', icon: <img src="/gift_lollipop.png" alt="Леденец" style={{width: 44, height: 44, objectFit: 'contain', borderRadius: 12, background: '#23242a', boxShadow: '0 2px 8px rgba(0,0,0,0.10)'}} />, value: 10 },
  { type: 'lootbag', label: 'Сумка с добычей', icon: <img src="https://nft.fragment.com/gift/lootbag-7631.webp" alt="Сумка с добычей" style={{width: 44, height: 44, objectFit: 'contain', borderRadius: 12, background: '#23242a', boxShadow: '0 2px 8px rgba(0,0,0,0.10)'}} />, value: 20 },
  { type: 'small', label: 'Маленький подарок', icon: '🎁', value: 15 },
  { type: 'medium', label: 'Средний подарок', icon: '🎁', value: 25 },
  { type: 'big', label: 'Большой подарок', icon: '🎁', value: 50 },
];
const GIFTS_50 = [
  { type: 'lollipop', label: 'Леденец', icon: <img src="/gift_lollipop.png" alt="Леденец" style={{width: 44, height: 44, objectFit: 'contain', borderRadius: 12, background: '#23242a', boxShadow: '0 2px 8px rgba(0,0,0,0.10)'}} />, value: 10 },
  { type: 'lootbag', label: 'Сумка с добычей', icon: <img src="https://nft.fragment.com/gift/lootbag-7631.webp" alt="Сумка с добычей" style={{width: 44, height: 44, objectFit: 'contain', borderRadius: 12, background: '#23242a', boxShadow: '0 2px 8px rgba(0,0,0,0.10)'}} />, value: 20 },
  { type: 'small', label: 'Маленький подарок', icon: '🎁', value: 15 },
  { type: 'medium', label: 'Средний подарок', icon: '🎁', value: 25 },
  { type: 'big', label: 'Большой подарок', icon: '🎁', value: 50 },
  { type: 'super', label: 'Супер подарок', icon: '🎁', value: 100 },
];

const GIFT_COLORS = {
  small: '#4fa3f7',
  medium: '#ffd700',
  big: '#ff6f61',
};

const STAKES = [25, 50];
const SLOT_LENGTH = 31;
const VISIBLE = 7;
const CENTER_IDX = Math.floor(VISIBLE / 2);
const ITEM_WIDTH = 80; // px, увеличено для широких подарков
const SLOT_HEIGHT = 90; // px, увеличено для лучшей видимости

// 1. Импортировать иконку <img src="/gems.png" ... /> для отображения валюты
const GemIcon = <img src="/gems.png" alt="gems" style={{width: 18, height: 18, verticalAlign: 'middle', marginLeft: 2, marginRight: 2}} />;

function getRandomGift(selectedTab) {
  const r = Math.random();
  if (selectedTab === 50) {
    if (r < 0.60) return GIFTS_50[0];
    if (r < 0.82) return GIFTS_50[1];
    if (r < 0.95) return GIFTS_50[2];
    return GIFTS_50[3];
  } else {
    if (r < 0.8) return GIFTS_25[0];
    if (r < 0.95) return GIFTS_25[1];
    return GIFTS_25[2];
  }
}

// Массив кейсов для страницы 'Кейсы'
const CASES = [
  {
    id: 'bloods',
    name: 'Bloods',
    image: '/caseblood.png',
    price: 799,
  },
  {
    id: 'broke',
    name: 'Broke',
    image: '/broke.png',
    price: 499,
  },
];

const MiniAppMain = () => {
  const [tgTheme, setTgTheme] = useState('dark');
  const [selectedTab, setSelectedTab] = useState(25);
  const [isSpinning, setIsSpinning] = useState(false);
  const [demoMode, setDemoMode] = useState(false);
  const [result, setResult] = useState(null);
  const [userBalance, setUserBalance] = useState(0);
  const [userId, setUserId] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isTelegramAvailable, setIsTelegramAvailable] = useState(false);
  const [balance, setBalance] = useState(100);
  const [selectedStake, setSelectedStake] = useState(25);
  const [slotGifts, setSlotGifts] = useState(() =>
    Array.from({ length: SLOT_LENGTH }, () => getRandomGift(25))
  );
  const [resultGift, setResultGift] = useState(null);
  const [offset, setOffset] = useState(0); // дробное смещение ленты
  const [showLeaders, setShowLeaders] = useState(false);
  const [mySpins, setMySpins] = useState(0);
  const [myTotalWin, setMyTotalWin] = useState(0);
  const [page, setPage] = useState('game'); // 'game' | 'leaders' | 'inventory' | 'cases'
  const [showTopup, setShowTopup] = useState(false);
  const [topupAmount, setTopupAmount] = useState('');
  const [showPrizeModal, setShowPrizeModal] = useState(false);
  const [modalGift, setModalGift] = useState(null);
  const [inventory, setInventory] = useState([]); // [{type, label, icon, value, count}]
  const [slotRef, setSlotRef] = useState(null);
  const [showCaseModal, setShowCaseModal] = useState(false);
  const [selectedCase, setSelectedCase] = useState(null);
  const [isOpening, setIsOpening] = useState(false);
  const [droppedPrize, setDroppedPrize] = useState(null);
  const [caseAnimState, setCaseAnimState] = useState('idle'); // 'idle' | 'spinning' | 'jump' | 'done'
  const [caseAnimOffset, setCaseAnimOffset] = useState(0); // transform X
  const [casePrizesStrip, setCasePrizesStrip] = useState([]);
  const [casePrizeIndex, setCasePrizeIndex] = useState(0);
  const [caseJump, setCaseJump] = useState(false);
  const [caseSlotGifts, setCaseSlotGifts] = useState([]);
  const [caseOffset, setCaseOffset] = useState(0);
  const [caseIsSpinning, setCaseIsSpinning] = useState(false);
  const [caseResultGift, setCaseResultGift] = useState(null);
  const [showPromoModal, setShowPromoModal] = useState(false);
  const [promoInput, setPromoInput] = useState("");
  const [promoError, setPromoError] = useState("");
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [loadingText, setLoadingText] = useState("");
  // 1. Добавляем состояния для модалки вывода и выбранного подарка
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const [withdrawGift, setWithdrawGift] = useState(null);
  const [withdrawLoading, setWithdrawLoading] = useState(false);
  const [withdrawDone, setWithdrawDone] = useState(false);

  // Telegram WebApp API init
  useEffect(() => {
    if (window.Telegram && window.Telegram.WebApp) {
      window.Telegram.WebApp.ready();
      setTgTheme(window.Telegram.WebApp.colorScheme || 'dark');
      setIsTelegramAvailable(true);
      
      // Получаем данные пользователя
      const user = window.Telegram.WebApp.initDataUnsafe?.user;
      if (user) {
        setUserId(user.id);
        fetchUserBalance();
      } else {
        // Для тестирования используем фиктивный ID
        setUserId(123456789);
        // setUserBalance(50); // Тестовый баланс
      }
    } else {
      console.warn('Telegram WebApp API не доступен');
      // setUserBalance(50); // Тестовый баланс для разработки
    }
  }, []);

  const fetchUserBalance = async () => {
    try {
      if (isTelegramAvailable && window.Telegram.WebApp.getStarsBalance) {
        // Настоящий Telegram Stars API
        const balance = await window.Telegram.WebApp.getStarsBalance();
        setUserBalance(balance || 0);
      } else {
        // Fallback для разработки
        // setUserBalance(50);
      }
    } catch (error) {
      console.error('Error fetching balance:', error);
      // setUserBalance(50); // Тестовый баланс
    }
  };

  const showErrorMessage = (message) => {
    setErrorMessage(message);
    setShowError(true);
    setTimeout(() => setShowError(false), 3000);
  };

  const handleTab = (val) => {
    setSelectedTab(val);
    setSelectedStake(val);
  };

  const spin = async () => {
    if (isSpinning || !userId) return;

    // Проверяем баланс
    if (userBalance < 10) {
      showErrorMessage('Недостаточно средств на балансе');
      return;
    }

    setIsSpinning(true);
    setResult(null);
    
    // Анимация слотов
    let spins = 15;
    let interval = setInterval(() => {
      setSlotGifts(Array.from({ length: SLOT_LENGTH }, () => getRandomGift(selectedTab)));
      spins--;
      if (spins === 0) {
        clearInterval(interval);
        performSpin();
      }
    }, 80);
  };

  const performSpin = async () => {
    try {
      let spinResult = null;
      
      if (isTelegramAvailable && window.Telegram.WebApp.requestStars) {
        // Настоящий Telegram Stars API
        try {
          // Запрашиваем списание 10 звёзд
          const starsResult = await window.Telegram.WebApp.requestStars({
            amount: 10,
            currency: 'stars'
          });
          
          if (starsResult.success) {
            // Крутим слот и определяем выигрыш
            spinResult = await spinSlotLogic();
            
            // Если есть выигрыш, добавляем звёзды
            if (spinResult.win_amount > 0) {
              await window.Telegram.WebApp.requestStars({
                amount: spinResult.win_amount,
                currency: 'stars',
                operation: 'add'
              });
            }
            
            // Обновляем баланс
            await fetchUserBalance();
          } else {
            showErrorMessage('Не удалось списать звёзды');
            setIsSpinning(false);
            return;
          }
        } catch (error) {
          console.error('Error with Telegram Stars API:', error);
          showErrorMessage('Ошибка при работе с Telegram Stars');
          setIsSpinning(false);
          return;
        }
      } else {
        // Fallback: используем наш backend API
        const response = await fetch('http://localhost:8000/api/stars/spin', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user_id: userId,
            bet_amount: 10
          }),
        });

        const data = await response.json();
        if (data.success) {
          spinResult = {
            emoji: data.result,
            win_amount: data.win_amount
          };
          setUserBalance(data.new_balance);
        } else {
          showErrorMessage(data.message);
          setIsSpinning(false);
          return;
        }
      }
      
      // Обновляем слоты с результатом
      setSlotGifts(Array.from({ length: SLOT_LENGTH }, () => getRandomGift(selectedTab)));
      
      setResult({ emoji: spinResult.emoji, value: spinResult.win_amount });
      
      // Вибрация при выигрыше
      if (spinResult.win_amount > 0 && window.navigator.vibrate) {
        window.navigator.vibrate([100, 50, 100]);
      }
      
      if (!demoMode) setBalance(b => b - selectedStake + spinResult.win_amount);
      setMySpins(s => s + 1);
      setMyTotalWin(w => w + spinResult.win_amount);
      
      setModalGift(getRandomGift(selectedTab));
      setShowPrizeModal(true);
      
    } catch (error) {
      console.error('Error spinning:', error);
      showErrorMessage('Ошибка при игре');
    } finally {
      setIsSpinning(false);
    }
  };

  const spinSlotLogic = async () => {
    // Логика определения выигрыша
    const winChance = Math.random() * 100;
    
    if (winChance < 0.806) {
      return { emoji: '🏆', win_amount: 100 };
    } else if (winChance < 25.806) {
      return { emoji: '🌹', win_amount: 25 };
    } else if (winChance < 27.016) {
      return { emoji: '🎂', win_amount: 50 };
    } else {
      return { emoji: '😔', win_amount: 0 };
    }
  };

  // Анимация прокрутки ленты
  const spinSlot = () => {
    if (isSpinning || userBalance < selectedStake) return;
    setLoadingText('Списание...');
    setShowLoadingModal(true);
    setTimeout(() => {
      if (!demoMode && userBalance < selectedStake) {
        setShowLoadingModal(false);
        showErrorMessage('Недостаточно средств на балансе');
        return;
      }
      if (!demoMode) setUserBalance(b => b - selectedStake);
      setShowLoadingModal(false);
      setIsSpinning(true);
      setResultGift(null);
      const winGift = getRandomGift(selectedTab);
      let gifts = Array.from({ length: SLOT_LENGTH }, () => getRandomGift(selectedTab));
      const winIdx = CENTER_IDX + Math.floor(SLOT_LENGTH / 2);
      gifts[winIdx] = winGift;
      setSlotGifts(gifts);
      const offsetWin = -(winIdx - CENTER_IDX) * ITEM_WIDTH;
      let duration = 5000 + Math.random() * 1000;
      let start = performance.now();
      function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }
      function animate(now) {
        let elapsed = now - start;
        let progress = Math.min(elapsed / duration, 1);
        let currentOffset = easeOutQuart(progress) * offsetWin;
        setOffset(currentOffset);
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          setOffset(offsetWin);
          setResultGift(winGift);
          setIsSpinning(false);
          if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.HapticFeedback) {
            window.Telegram.WebApp.HapticFeedback.impactOccurred('medium');
          } else if (window.navigator.vibrate) {
            window.navigator.vibrate([80, 40, 80]);
          }
          if (!demoMode) setUserBalance(b => b + winGift.value);
          setMySpins(s => s + 1);
          setMyTotalWin(w => w + winGift.value);
          setModalGift(winGift);
          setShowPrizeModal(true);
        }
      }
      setOffset(0);
      requestAnimationFrame(animate);
    }, 1000);
  };

  // Получить индекс первого видимого элемента с плавным переходом
  const base = Math.floor(-offset / ITEM_WIDTH);

  // Получить видимые подарки (7 по центру) без зацикливания
  const getVisible = () => {
    const base = Math.floor(-offset / ITEM_WIDTH);
    return slotGifts.slice(base, base + VISIBLE).map((gift, i) => ({ ...gift, pos: i }));
  };

  // Мокаю топ-15 игроков и пользователя
  const myId = userId || 123;
  const allLeaders = [
    { id: 1, name: 'LuckyFox', spins: 123, win: 1500 },
    { id: 2, name: 'SpinMaster', spins: 98, win: 1200 },
    { id: 3, name: 'StarQueen', spins: 77, win: 900 },
    { id: 4, name: 'MrJackpot', spins: 70, win: 850 },
    { id: 5, name: 'CryptoCat', spins: 65, win: 800 },
    { id: 6, name: 'SlotWizard', spins: 60, win: 750 },
    { id: 7, name: 'CherryBlossom', spins: 55, win: 700 },
    { id: 8, name: 'NeonWolf', spins: 50, win: 650 },
    { id: 9, name: 'PixelTiger', spins: 45, win: 600 },
    { id: 10, name: 'LunaSpin', spins: 40, win: 550 },
    { id: 11, name: 'FastHand', spins: 35, win: 500 },
    { id: 12, name: 'Goldie', spins: 30, win: 450 },
    { id: 13, name: 'DiceyMike', spins: 25, win: 400 },
    { id: 14, name: 'VegaDream', spins: 20, win: 350 },
    { id: 15, name: 'AliceTG', spins: 15, win: 300 },
    // пользователь (может быть не в топе)
    { id: myId, name: 'Вы', spins: mySpins, win: myTotalWin },
  ];
  // Сортируем по выигрышу
  const sortedLeaders = [...allLeaders].sort((a, b) => b.win - a.win);
  const top15 = sortedLeaders.slice(0, 15);
  const myPlace = sortedLeaders.findIndex(u => u.id === myId) + 1;
  const inTop = top15.some(u => u.id === myId);
  const myRow = { place: myPlace, ...sortedLeaders[myPlace - 1] };

  const gifts = selectedTab === 50 ? GIFTS_50 : GIFTS_25;

  const handleSellGift = () => {
    // В демо режиме не начисляем средства на баланс
    if (!demoMode) {
      setUserBalance(b => b + (modalGift?.value || 0));
    }
    setShowPrizeModal(false);
  };

  const handleKeepGift = () => {
    if (modalGift) {
      setInventory(inv => {
        const idx = inv.findIndex(g => g.type === modalGift.type);
        if (idx >= 0) {
          const updated = [...inv];
          updated[idx] = {...updated[idx], count: updated[idx].count + 1};
          return updated;
        } else {
          return [...inv, {...modalGift, count: 1}];
        }
      });
    }
    setShowPrizeModal(false);
  };

  const handleKeepCasePrize = () => {
    if (droppedPrize) {
      setInventory(inv => {
        const idx = inv.findIndex(g => g.label === droppedPrize.label);
        if (idx >= 0) {
          const updated = [...inv];
          updated[idx] = { ...updated[idx], count: updated[idx].count + 1 };
          return updated;
        } else {
          return [...inv, { ...droppedPrize, count: 1 }];
        }
      });
    }
    setDroppedPrize(null);
    setShowCaseModal(false);
  };

  // 2. Моки для предметов кейса
  const CASE_PRIZES = {
    bloods: [
      { label: 'Леденец', icon: <img src="/gift_lollipop.png" alt="Леденец" style={{width: 36, height: 36}} />, chance: 60, value: 10 },
      { label: 'Сумка с добычей', icon: <img src="https://nft.fragment.com/gift/lootbag-7631.webp" alt="Сумка" style={{width: 36, height: 36}} />, chance: 30, value: 20 },
      { label: 'Маленький подарок', icon: '🎁', chance: 10, value: 15 },
    ],
    broke: [
      { label: 'Котёл', icon: <img src="https://nft.fragment.com/gift/hexpot-20348.webp" alt="Котёл" style={{width: 36, height: 36}} />, chance: 70, value: 5 },
      { label: 'Сюрприз', icon: '🎉', chance: 30, value: 25 },
    ]
  };

  // 2. Функция открытия кейса
  const handleOpenCase = () => {
    if (!selectedCase) return;
    setLoadingText('Списание...');
    setShowLoadingModal(true);
    setTimeout(() => {
      if (userBalance < selectedCase.price) {
        setShowLoadingModal(false);
        showErrorMessage('Недостаточно средств для открытия кейса');
        return;
      }
      setUserBalance(b => b - selectedCase.price);
      setShowLoadingModal(false);
      // ... анимация открытия кейса ...
      const prizes = CASE_PRIZES[selectedCase.id] || [];
      const winGift = prizes[Math.floor(Math.random() * prizes.length)];
      const SLOT_LENGTH_CASE = 31;
      const CENTER_IDX_CASE = Math.floor(7 / 2);
      let gifts = Array.from({ length: SLOT_LENGTH_CASE }, () => prizes[Math.floor(Math.random() * prizes.length)]);
      const winIdx = CENTER_IDX_CASE + Math.floor(SLOT_LENGTH_CASE / 2);
      gifts[winIdx] = winGift;
      setCaseSlotGifts(gifts);
      const ITEM_WIDTH_CASE = 54;
      const offsetWin = -(winIdx - CENTER_IDX_CASE) * ITEM_WIDTH_CASE;
      let duration = 5000 + Math.random() * 1000;
      let start = performance.now();
      function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }
      function animate(now) {
        let elapsed = now - start;
        let progress = Math.min(elapsed / duration, 1);
        let currentOffset = easeOutQuart(progress) * offsetWin;
        setCaseOffset(currentOffset);
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          setCaseOffset(offsetWin);
          setCaseResultGift(winGift);
          setCaseIsSpinning(false);
          setDroppedPrize(winGift);
        }
      }
      setCaseOffset(0);
      setCaseIsSpinning(true);
      setCaseResultGift(null);
      requestAnimationFrame(animate);
    }, 1000);
  };

  // --- onTransitionEnd для ленты ---
  const handleCaseTransitionEnd = () => {
    if (caseAnimState === 'spinning') {
      // JUMP-эффект: если справа от выигрыша другой приз, делаем "отскок"
      const rightPrize = casePrizesStrip[casePrizeIndex + 1];
      const winPrize = casePrizesStrip[casePrizeIndex];
      if (rightPrize && rightPrize !== winPrize) {
        setCaseAnimState('jump');
        setCaseAnimOffset(54 * (casePrizeIndex + 1)); // смещаем на 1 вправо
        setTimeout(() => {
          setCaseAnimOffset(54 * casePrizeIndex); // возвращаем на выигрыш
          setTimeout(() => {
            setCaseAnimState('done');
            setIsSpinning(false);
            setDroppedPrize(winPrize);
            setIsOpening(false);
            setCaseJump(false);
          }, 300);
        }, 300);
      } else {
        setCaseAnimState('done');
        setIsSpinning(false);
        setDroppedPrize(winPrize);
        setIsOpening(false);
      }
    }
  };

  // функция активации промокода
  const handlePromo = () => {
    if (promoInput.trim().toUpperCase() === "TEST5000") {
      setUserBalance(b => b + 5000);
      setShowPromoModal(false);
      setPromoInput("");
      setPromoError("");
      showErrorMessage("Промокод активирован! +5000");
    } else {
      setPromoError("Неверный промокод");
    }
  };

  const handleSellInventoryGift = (gift) => {
    setInventory(inv => {
      const idx = inv.findIndex(g => g.type === gift.type);
      if (idx === -1) return inv;
      const updated = [...inv];
      if (updated[idx].count > 1) {
        updated[idx] = { ...updated[idx], count: updated[idx].count - 1 };
      } else {
        updated.splice(idx, 1);
      }
      return updated;
    });
    setUserBalance(b => b + gift.value);
    showErrorMessage(`Подарок продан! +${gift.value}`);
  };

  // 2. Функция для открытия модалки вывода
  const handleWithdrawGift = (gift) => {
    setWithdrawGift(gift);
    setShowWithdrawModal(true);
    setWithdrawLoading(true);
    setWithdrawDone(false);
    setTimeout(() => {
      setWithdrawLoading(false);
      setWithdrawDone(true);
    }, 1200);
  };

  return (
    <div className={`tg-miniapp-root ${tgTheme}`}>
      <div className="tg-header">
        <span className="tg-close" onClick={() => window.Telegram?.WebApp?.close()}>
          Закрыть
        </span>
        <div className="tg-title-block">
          <div className="tg-title" style={{display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center'}}>
            <img src="/logo.png" alt="StarCasino" style={{height: 44, marginRight: 10, verticalAlign: 'middle'}} />
            <span style={{fontWeight: 800, fontSize: '1.25em', letterSpacing: 0.5}}>StarCasino</span>
          </div>
          <div className="tg-subtitle">мини-приложение</div>
        </div>
        <span className="tg-menu">⋯</span>
      </div>
      {page === 'game' && (
        <>
          {/* Баланс и кнопка пополнения */}
          <div className="tg-balance-display" style={{display: 'flex', alignItems: 'center', gap: 8}}>
            Баланс: <span style={{color: '#1ed760', fontWeight: 700, fontSize: '1.1em'}}>{demoMode ? (
              <span style={{display: 'inline-block', verticalAlign: 'middle', marginRight: 2}}>
                <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: 'relative', top: 1}}>
                  <path d="M2 5C2 2.79086 3.79086 1 6 1C7.65685 1 9 2.34315 9 4C9 5.65685 7.65685 7 6 7C3.79086 7 2 5.20914 2 3Z" stroke="#1ed760" strokeWidth="2" fill="none"/>
                  <path d="M16 5C16 2.79086 14.2091 1 12 1C10.3431 1 9 2.34315 9 4C9 5.65685 10.3431 7 12 7C14.2091 7 16 5.20914 16 3Z" stroke="#1ed760" strokeWidth="2" fill="none"/>
                </svg>
              </span>
            ) : userBalance} {GemIcon}</span>
            <button style={{marginLeft: 8, padding: '2px 10px', borderRadius: 8, border: 'none', background: '#4fa3f7', color: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: '0.95em'}} onClick={() => setShowTopup(true)}>Пополнить</button>
            {!isTelegramAvailable && <div style={{fontSize: '0.8rem', color: '#aaa'}}>Режим разработки</div>}
          </div>

          {/* Tabs */}
          <div className="tg-tabs">
            <div
              className={`tg-tab${selectedTab === 25 ? ' active' : ''}`}
              onClick={() => handleTab(25)}
            >
              25 {GemIcon}
            </div>
            <div
              className={`tg-tab${selectedTab === 50 ? ' active' : ''}`}
              onClick={() => handleTab(50)}
            >
              50 {GemIcon}
            </div>
          </div>

          {/* Слот-машина */}
          <div className="tg-slot-outer" style={{ width: '100%', maxWidth: `${ITEM_WIDTH * VISIBLE}px`, position: 'relative', overflow: 'hidden', margin: '32px auto 10px auto', height: `${SLOT_HEIGHT}px` }}>
            {/* Верхняя стрелка */}
            <svg width="48" height="12" viewBox="0 0 48 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', zIndex: 50, pointerEvents: 'none'}}>
              <line x1="0" y1="2" x2="48" y2="2" stroke="#4fa3f7" strokeWidth="2" strokeLinecap="round" />
              <polygon points="17,2 31,2 24,8" fill="#23242a" stroke="#4fa3f7" strokeWidth="2" />
            </svg>
            {/* Нижняя стрелка */}
            <svg width="48" height="12" viewBox="0 0 48 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', zIndex: 50, pointerEvents: 'none'}}>
              <line x1="0" y1="10" x2="48" y2="10" stroke="#4fa3f7" strokeWidth="2" strokeLinecap="round" />
              <polygon points="17,10 31,10 24,4" fill="#23242a" stroke="#4fa3f7" strokeWidth="2" />
            </svg>
            <div
              className="tg-slot-strip"
              style={{
                width: `${ITEM_WIDTH * SLOT_LENGTH}px`,
                height: `${SLOT_HEIGHT}px`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transform: `translateX(calc(50% - ${(VISIBLE / 2) * ITEM_WIDTH}px + ${offset}px))`,
                transition: 'none'
              }}
            >
              {slotGifts.map((gift, idx) => {
                const centerIdx = base + CENTER_IDX;
                const distToCenter = idx - centerIdx;
                const isCenter = Math.abs(distToCenter) < 0.15;
                const isWinner = isCenter && resultGift && !isSpinning;
                return (
                  <div
                    key={idx}
                    className={`tg-slot-gift${isCenter ? ' center' : ''}${isWinner ? ' winner' : ''}`}
                    style={{
                      width: ITEM_WIDTH,
                      height: SLOT_HEIGHT,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.4rem',
                      background: '#23242a',
                      borderRadius: 14,
                      margin: '0 0px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                      border: isCenter ? '2px solid transparent' : '2px solid transparent',
                      opacity: isCenter ? 1 : 0.7,
                      transition: 'none',
                      paddingTop: 4,
                      paddingBottom: 4,
                    }}
                  >
                    <span className="tg-gift-icon" style={{fontSize: '1.7rem'}}>{gift.icon}</span>
                    <span className="tg-gift-value" style={{fontSize: '1.1rem', color: '#1ed760', fontWeight: 700}}>{gift.value} {GemIcon}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Демо режим */}
          <div className="tg-demo-row">
            <span>Демо режим</span>
            <label className="tg-switch">
              <input type="checkbox" checked={demoMode} onChange={() => setDemoMode(!demoMode)} />
              <span className="slider"></span>
            </label>
          </div>

          {/* Кнопка */}
          <button
            className={`tg-spin-btn${isSpinning || userBalance < selectedStake ? ' disabled' : ''}`}
            onClick={spinSlot}
            disabled={isSpinning || userBalance < selectedStake}
            style={{
              display: 'block',
              margin: '18px auto',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
              background: '#a259ff',
              color: '#fff',
              fontWeight: 700,
              fontSize: '1.15em',
              border: 'none',
              borderRadius: 12,
              boxShadow: '0 0 8px #a259ff55',
              cursor: isSpinning || userBalance < selectedStake ? 'not-allowed' : 'pointer',
              opacity: isSpinning || userBalance < selectedStake ? 0.7 : 1
            }}
          >
            <img
              src="/slot.png"
              alt="slot"
              style={{
                width: 24,
                height: 24,
                marginRight: 8,
                verticalAlign: 'middle',
                display: 'inline-block',
                transition: 'transform 0.3s',
                animation: isSpinning ? 'spin-rotate 1s linear infinite' : 'none'
              }}
            />
            {isSpinning ? 'КРУТИМ...' : <>МНЕ ПОВЕЗЁТ! {selectedStake} {GemIcon}</>}
          </button>

          {/* Результат */}
          {result && (
            <div className="tg-result-block">
              <span>Ваш выигрыш: </span>
              <span className="tg-result-emoji">{result.emoji}</span>
              <span className="tg-result-value">{result.value} {GemIcon}</span>
            </div>
          )}

          {/* Список призов */}
          <div className="tg-prizes-title">Вы можете выиграть...</div>
          <div className="tg-prizes-list">
            {gifts.map((prize, idx) => (
              <div key={idx} className="tg-prize">
                <div className="tg-prize-chance" style={{color: '#4fa3f7', fontWeight: 700, fontSize: '1.2em'}}>
                  {selectedTab === 50
                    ? [35, 25, 25, 15][idx]
                    : [60, 30, 10][idx]
                  }%
                </div>
                <div className="tg-prize-emoji">{prize.icon}</div>
                <div className="tg-prize-label" style={{
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '0.95em',
                  textAlign: 'center',
                  marginTop: 4,
                  maxWidth: 72,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}>
                  {prize.label}
                </div>
              </div>
            ))}
          </div>

          {/* Анимированная ошибка */}
          {showError && (
            <div className="tg-error-message">
              {errorMessage}
            </div>
          )}
        </>
      )}
      {page === 'leaders' && (
        <div style={{padding: '18px 0 80px 0', minHeight: '100vh', background: '#181a20', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <div style={{fontWeight: 800, fontSize: '1.25em', color: '#a259ff', margin: '18px 0 12px 0', textAlign: 'center', fontFamily: 'Inter, Arial, sans-serif', letterSpacing: 0.2}}>Топ игроков</div>
          <div style={{width: '100%', maxWidth: 370, background: 'none', overflowY: 'auto', flex: 1}}>
            {top15.map((u, i) => (
              <div key={u.id} style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 18px', background: u.id === myId ? 'rgba(79,163,247,0.10)' : '#23242a', borderRadius: 12, marginBottom: 8, fontWeight: u.id === myId ? 700 : 500, color: u.id === myId ? '#4fa3f7' : '#fff', fontSize: '1.05em'}}>
                <span style={{width: 28, textAlign: 'center', color: i === 0 ? '#a259ff' : '#aaa', fontWeight: i === 0 ? 800 : 700, fontFamily: 'Inter, Arial, sans-serif'}}>{i + 1}</span>
                <span style={{flex: 1, marginLeft: 8}}>{u.name}</span>
                <span style={{width: 60, textAlign: 'center'}}>{u.spins}</span>
                <span style={{width: 70, textAlign: 'right'}}>{u.win} {GemIcon}</span>
              </div>
            ))}
          </div>
          {!inTop && (
            <div style={{position: 'sticky', bottom: 64, left: 0, right: 0, width: '100%', maxWidth: 370, margin: '0 auto', background: 'rgba(24,26,32,0.98)', borderRadius: 12, padding: '12px 18px', fontWeight: 700, color: '#4fa3f7', fontSize: '1.05em', display: 'flex', alignItems: 'center', justifyContent: 'space-between', zIndex: 10, boxShadow: '0 2px 8px rgba(79,163,247,0.10)'}}>
              <span style={{width: 28, textAlign: 'center', color: '#aaa'}}>{myRow.place}</span>
              <span style={{flex: 1, marginLeft: 8}}>{myRow.name}</span>
              <span style={{width: 60, textAlign: 'center'}}>{myRow.spins}</span>
              <span style={{width: 70, textAlign: 'right'}}>{myRow.win} {GemIcon}</span>
            </div>
          )}
        </div>
      )}
      {showPrizeModal && modalGift && (
        <div className="tg-modal-bg" style={{position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.55)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <div className="tg-modal-prize" style={{background: '#23242a', borderRadius: 18, padding: 32, minWidth: 280, boxShadow: '0 4px 24px rgba(0,0,0,0.18)', display: 'flex', flexDirection: 'column', alignItems: 'center', animation: 'fadeIn 0.4s'}}>
            <div style={{fontWeight: 800, fontSize: '1.3em', color: '#4fa3f7', marginBottom: 10}}>Вы выиграли!</div>
            <div style={{marginBottom: 12, fontSize: 48}}>{modalGift.icon}</div>
            <div style={{fontWeight: 700, fontSize: '1.1em', color: '#fff', marginBottom: 8}}>{modalGift.label}</div>
            <div style={{color: '#4fa3f7', fontWeight: 700, marginBottom: 18}}>Мгновенная продажа: {modalGift.value} {GemIcon}</div>
            <button onClick={handleSellGift} style={{
              padding: '10px 28px',
              borderRadius: 12,
              border: 'none',
              background: '#a259ff',
              color: '#fff',
              fontWeight: 700,
              fontSize: '1.1em',
              marginBottom: 10,
              cursor: 'pointer',
              boxShadow: '0 0 8px #a259ff55',
              transition: 'background 0.2s'
            }}>
              {demoMode ? 'Продать (демо)' : <>Продать за {modalGift.value} {GemIcon}</>}
            </button>
            <button onClick={handleKeepGift} style={{
              padding: '8px 18px',
              borderRadius: 12,
              border: '2px solid #a259ff',
              background: 'transparent',
              color: '#fff',
              fontWeight: 700,
              fontSize: '1em',
              cursor: 'pointer',
              transition: 'border 0.2s, background 0.2s'
            }}>
              Оставить себе
            </button>
          </div>
        </div>
      )}
      {/* Нижнее меню */}
      <div className="tg-bottom-nav" style={{position: 'fixed', left: 0, right: 0, bottom: 0, background: '#23242a', display: 'flex', justifyContent: 'space-around', alignItems: 'center', height: 60, borderTop: '1px solid #23242a', zIndex: 100}}>
        <div className={`tg-nav-item${page === 'cases' ? ' active' : ''}`} onClick={() => setPage('cases')} style={{cursor: 'pointer'}}>
          <img src="/cases.png" alt="Кейсы" style={{width: 26, height: 26, display: 'block', margin: '0 auto'}} />
          <div style={{fontWeight: 600, fontSize: '1.05em', fontFamily: 'Inter, Arial, sans-serif', marginTop: 2, letterSpacing: 0.1}}>Кейсы</div>
        </div>
        <div className={`tg-nav-item${page === 'leaders' ? ' active' : ''}`} onClick={() => setPage('leaders')} style={{cursor: 'pointer'}}>
          <img src="/leaders.png" alt="Лидеры" style={{width: 26, height: 26, display: 'block', margin: '0 auto'}} />
          <div style={{fontWeight: 600, fontSize: '1.05em', fontFamily: 'Inter, Arial, sans-serif', marginTop: 2, letterSpacing: 0.1}}>Лидеры</div>
        </div>
        <div className={`tg-nav-item${page === 'game' ? ' active' : ''}`} onClick={() => setPage('game')} style={{cursor: 'pointer'}}>
          <img src="/play.png" alt="Играть" style={{width: 26, height: 26, display: 'block', margin: '0 auto'}} />
          <div style={{fontWeight: 600, fontSize: '1.05em', fontFamily: 'Inter, Arial, sans-serif', marginTop: 2, letterSpacing: 0.1}}>Играть</div>
        </div>
        <div className={`tg-nav-item${page === 'inventory' ? ' active' : ''}`} onClick={() => setPage('inventory')} style={{cursor: 'pointer'}}>
          <img src="/inventory.png" alt="Инвентарь" style={{width: 26, height: 26, display: 'block', margin: '0 auto'}} />
          <div style={{fontWeight: 600, fontSize: '1.05em', fontFamily: 'Inter, Arial, sans-serif', marginTop: 2, letterSpacing: 0.1}}>Инвентарь</div>
        </div>
      </div>
      {page === 'inventory' && (
        <div style={{padding: '18px 0 80px 0', minHeight: '100vh', background: '#181a20', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', maxWidth: 370, marginBottom: 8}}>
            <div style={{fontWeight: 700, fontSize: '1.2em', color: '#4fa3f7', textAlign: 'center'}}>Ваш инвентарь</div>
            <button onClick={() => setShowPromoModal(true)} style={{padding: '6px 16px', borderRadius: 10, border: '2px solid #a259ff', background: '#a259ff', color: '#fff', fontWeight: 700, fontSize: '1em', marginLeft: 8, cursor: 'pointer', boxShadow: '0 0 8px #a259ff55'}}>Промо</button>
          </div>
          {inventory.length === 0 ? (
            <div style={{color: '#aaa', fontSize: '1.1em', marginTop: 40}}>Пока нет подарков</div>
          ) : (
            <div style={{width: '100%', maxWidth: 370, background: 'none', overflowY: 'auto', flex: 1}}>
              {inventory.map((gift, i) => (
                <div key={gift.type} style={{display: 'flex', alignItems: 'flex-start', padding: '12px 18px', background: '#23242a', borderRadius: 12, marginBottom: 8, fontWeight: 600, color: '#fff', fontSize: '1.05em', gap: 14}}>
                  <span style={{fontSize: 32, marginRight: 0, flexShrink: 0}}>{gift.icon}</span>
                  <div style={{flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                    <div style={{fontWeight: 700, fontSize: '1.05em', lineHeight: 1.18, maxHeight: '2.4em', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'normal', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', marginBottom: 2}}>{gift.label}</div>
                    <div style={{display: 'flex', alignItems: 'center', gap: 10, marginBottom: 2}}>
                      <span style={{color: '#4fa3f7', fontWeight: 700, fontSize: '0.98em', whiteSpace: 'nowrap'}}>{gift.count} шт.</span>
                      <span style={{color: '#1ed760', fontWeight: 700, fontSize: '1.05em', marginRight: 2}}>{gift.value}</span>
                      <span>{GemIcon}</span>
                    </div>
                    <div style={{display: 'flex', gap: 8, marginTop: 4}}>
                      <button onClick={() => handleSellInventoryGift(gift)} style={{padding: '6px 14px', borderRadius: 8, border: '2px solid #a259ff', background: '#a259ff', color: '#fff', fontWeight: 700, fontSize: '0.95em', cursor: 'pointer'}}>Продать</button>
                      <button onClick={() => handleWithdrawGift(gift)} style={{padding: '6px 14px', borderRadius: 8, border: '2px solid #4fa3f7', background: '#23242a', color: '#4fa3f7', fontWeight: 700, fontSize: '0.95em', cursor: 'pointer'}}>Вывести</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      {page === 'cases' && (
        <div style={{minHeight: '100vh', background: '#181a20', padding: '0 0 80px 0', fontFamily: 'Inter, Arial, sans-serif'}}>
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '24px 18px 10px 18px'}}>
            <div style={{fontWeight: 800, fontSize: '1.3em', color: '#fff', letterSpacing: 0.5}}>StarCasino</div>
            <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
              <span style={{color: '#1ed760', fontWeight: 700, fontSize: '1.1em'}}>{userBalance} {GemIcon}</span>
              <button style={{background: '#23242a', color: '#4fa3f7', border: 'none', borderRadius: 10, padding: '6px 16px', fontWeight: 700, fontSize: '1em', display: 'flex', alignItems: 'center', gap: 6, boxShadow: '0 2px 8px rgba(0,0,0,0.10)', cursor: 'pointer'}} onClick={() => setShowTopup(true)}>+ Пополнить</button>
            </div>
          </div>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 12,
            justifyContent: 'space-between',
            padding: '0 8px'
          }}>
            {CASES.map(cs => (
              <div
                key={cs.id}
                onClick={() => { setSelectedCase(cs); setShowCaseModal(true); }}
                style={{
                  background: '#23242a',
                  borderRadius: 12,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
                  border: '1px solid #23242a',
                  width: '48%',
                  marginBottom: 14,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  padding: '4px 4px 10px 4px',
                  minHeight: 170,
                  cursor: 'pointer'
                }}
              >
                <img
                  src={cs.image}
                  alt={cs.name}
                  style={{
                    width: 'auto',
                    height: 110,
                    maxWidth: '100%',
                    display: 'block',
                    margin: '0 auto',
                    objectFit: 'contain',
                    borderRadius: 10,
                    background: 'none',
                    marginTop: 0,
                    marginBottom: 0
                  }}
                />
                <div style={{color: '#fff', fontWeight: 700, fontSize: '1.1em', marginBottom: 6, textAlign: 'center', fontFamily: 'Inter, Arial, sans-serif'}}>{cs.name}</div>
                <div style={{color: '#1ed760', fontWeight: 700, fontSize: '1em', display: 'flex', alignItems: 'center', gap: 4}}>{cs.price} {GemIcon}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      {showCaseModal && selectedCase && (
        <>
          <div style={{position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(24,26,32,0.65)', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)', zIndex: 9998}} />
          <div className="tg-modal-bg" style={{position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.00)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: droppedPrize ? 'none' : 'auto'}}>
            <div className="tg-modal-case" style={{background: '#23242a', borderRadius: 18, padding: 28, minWidth: 320, maxWidth: 360, boxShadow: '0 4px 24px rgba(0,0,0,0.18)', display: 'flex', flexDirection: 'column', alignItems: 'center', animation: 'fadeIn 0.4s', position: 'relative', pointerEvents: 'auto', overflow: 'hidden'}}>
              {/* Крестик только если нет выигрыша */}
              {!droppedPrize && (
                <button onClick={() => { setShowCaseModal(false); setIsOpening(false); setCaseIsSpinning(false); setDroppedPrize(null); }} style={{position: 'absolute', right: 12, top: 8, background: 'none', border: 'none', color: '#aaa', fontSize: 24, cursor: 'pointer', zIndex: 10}}>×</button>
              )}
              <div style={{height: 8}} />
              <img src={selectedCase.image} alt={selectedCase.name} style={{
                width: '98%',
                height: 170,
                objectFit: 'contain',
                borderRadius: 18,
                boxShadow: '0 4px 24px #000a',
                background: '#181a20',
                marginTop: 0,
                marginBottom: 14,
                transition: 'transform 0.4s',
                transform: caseIsSpinning ? 'scale(1.10)' : 'scale(1)'
              }} />
              <div style={{fontWeight: 800, fontSize: '1.2em', color: '#fff', marginBottom: 10}}>{selectedCase.name}</div>
              {/* Кейс-рулетка с эффектом "спрятанной полоски" и fade */}
              {(caseIsSpinning || (!droppedPrize && !caseResultGift)) && (
                <div className="tg-slot-outer" style={{
                  width: '100%',
                  maxWidth: `${72 * 7}px`,
                  position: 'relative',
                  overflow: 'hidden',
                  margin: '18px auto 10px auto',
                  height: caseIsSpinning ? '110px' : '32px',
                  transition: 'height 0.5s cubic-bezier(.4,2,.6,1), box-shadow 0.4s, transform 0.5s, opacity 0.5s',
                  boxShadow: caseIsSpinning ? '0 0 32px 10px #a259ff55' : 'none',
                  borderRadius: 18,
                  background: '#181a20',
                  transform: caseIsSpinning ? 'scaleY(1)' : 'scaleY(0.3)',
                  opacity: caseIsSpinning ? 1 : 0.2
                }}>
                  {/* Верхняя стрелка */}
                  <svg width="64" height="18" viewBox="0 0 64 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', zIndex: 50, pointerEvents: 'none'}}>
                    <line x1="0" y1="2" x2="64" y2="2" stroke="#4fa3f7" strokeWidth="2" strokeLinecap="round" />
                    <polygon points="27,2 37,2 32,10" fill="#23242a" stroke="#4fa3f7" strokeWidth="2" />
                  </svg>
                  {/* Нижняя стрелка */}
                  <svg width="64" height="18" viewBox="0 0 64 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', zIndex: 50, pointerEvents: 'none'}}>
                    <line x1="0" y1="16" x2="64" y2="16" stroke="#4fa3f7" strokeWidth="2" strokeLinecap="round" />
                    <polygon points="27,16 37,16 32,8" fill="#23242a" stroke="#4fa3f7" strokeWidth="2" />
                  </svg>
                  <div
                    className="tg-slot-strip"
                    style={{
                      width: `${72 * 31}px`,
                      height: `72px`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transform: `translateX(calc(50% - ${(7 / 2) * 72}px + ${caseOffset}px))`,
                      transition: 'none'
                    }}
                  >
                    {caseSlotGifts.map((gift, idx) => {
                      const centerIdx = Math.floor(7 / 2) + Math.floor(31 / 2);
                      const distToCenter = idx - centerIdx;
                      const isCenter = Math.abs(distToCenter) < 0.15;
                      const isWinner = isCenter && caseResultGift && !caseIsSpinning;
                      return (
                        <div
                          key={idx}
                          className={`tg-slot-gift${isCenter ? ' center' : ''}${isWinner ? ' winner' : ''}`}
                          style={{
                            width: 72,
                            height: 72,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '1.7rem',
                            background: '#23242a',
                            borderRadius: 16,
                            margin: '0 0px',
                            boxShadow: '0 2px 12px rgba(0,0,0,0.14)',
                            border: isCenter ? '2px solid transparent' : '2px solid transparent',
                            opacity: isCenter ? 1 : 0.7,
                            transition: 'none',
                            paddingTop: 6,
                            paddingBottom: 6,
                          }}
                        >
                          <span className="tg-gift-icon" style={{fontSize: '2.1rem'}}>{gift.icon}</span>
                          <span className="tg-gift-value" style={{fontSize: '1.2rem', color: '#1ed760', fontWeight: 700}}>{gift.value} {GemIcon}</span>
                        </div>
                      );
                    })}
                  </div>
                  {/* Fade-оверлеи только во время анимации */}
                  {caseIsSpinning && <>
                    <div style={{position: 'absolute', left: 0, top: 0, width: 54, height: '100%', pointerEvents: 'none', zIndex: 30, background: 'linear-gradient(to right, #181a20 80%, transparent)', opacity: 1, borderRadius: '18px 0 0 18px', transition: 'opacity 0.4s'}} />
                    <div style={{position: 'absolute', right: 0, top: 0, width: 54, height: '100%', pointerEvents: 'none', zIndex: 30, background: 'linear-gradient(to left, #181a20 80%, transparent)', opacity: 1, borderRadius: '0 18px 18px 0', transition: 'opacity 0.4s'}} />
                  </>}
                </div>
              )}
              {/* Текст Крутится... */}
              {caseIsSpinning && (
                <div style={{color: '#4fa3f7', fontWeight: 700, fontSize: '1.1em', marginBottom: 10, opacity: 0.85}}>Крутится...</div>
              )}
              {/* Блок шансов с анимацией уезда вниз */}
              <div className={`prizes-list${caseIsSpinning ? ' hide' : ''}`} style={{width: '100%', marginBottom: 18, transition: 'transform 0.4s, opacity 0.4s', transform: caseIsSpinning ? 'translateY(80px)' : 'translateY(0)', opacity: caseIsSpinning ? 0 : 1}}>
                {CASE_PRIZES[selectedCase.id]?.map((prize, i) => (
                  <div key={i} style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #23242a'}}>
                    <span style={{fontSize: 28, marginRight: 10}}>{prize.icon}</span>
                    <span style={{flex: 1, color: '#fff', fontWeight: 600}}>{prize.label}</span>
                    <span style={{color: '#4fa3f7', fontWeight: 700, marginRight: 8}}>{prize.chance}%</span>
                    <span style={{color: '#1ed760', fontWeight: 700}}>{prize.value} {GemIcon}</span>
                  </div>
                ))}
              </div>
              {/* Кнопка Открыть кейс */}
              {!caseIsSpinning && !droppedPrize && (
                <button onClick={handleOpenCase} style={{padding: '12px 32px', borderRadius: 12, border: '2px solid #4fa3f7', background: '#4fa3f7', color: '#fff', fontWeight: 800, fontSize: '1.1em', marginTop: 8, cursor: 'pointer', boxShadow: '0 0 8px #1ed76055'}}>
                  Открыть кейс за {selectedCase.price} {GemIcon}
                </button>
              )}
              {/* Модалка с выигрышем */}
              {droppedPrize && (
                <>
                  <div style={{position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(24,26,32,0.65)', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)', zIndex: 9998}} />
                  <div style={{marginTop: 18, width: '100%', background: '#23242a', borderRadius: 14, padding: 18, boxShadow: '0 4px 32px #000a, 0 0 0 2px #23242a', display: 'flex', flexDirection: 'column', alignItems: 'center', animation: 'fadeIn 0.4s', zIndex: 10000}}>
                    <div style={{fontWeight: 800, fontSize: '1.2em', color: '#4fa3f7', marginBottom: 10}}>Вы выиграли!</div>
                    <div style={{fontSize: 48, marginBottom: 8, border: '3px solid #4fa3f7', borderRadius: 12, boxShadow: '0 0 0 4px #4fa3f7, 0 0 16px #00f0ff99', padding: 8, background: '#181a20'}}>{droppedPrize.icon}</div>
                    <div style={{fontWeight: 700, fontSize: '1.1em', color: '#fff', marginBottom: 8}}>{droppedPrize.label}</div>
                    <div style={{color: '#4fa3f7', fontWeight: 700, marginBottom: 18}}>Цена: {droppedPrize.value} {GemIcon}</div>
                    <button onClick={handleKeepCasePrize} style={{padding: '10px 28px', borderRadius: 10, border: '2px solid #4fa3f7', background: '#4fa3f7', color: '#fff', fontWeight: 700, fontSize: '1.1em', marginBottom: 10, cursor: 'pointer', boxShadow: '0 0 8px #1ed76055'}}>Оставить себе</button>
                    <button onClick={() => { 
                      // В демо режиме не начисляем средства на баланс
                      if (!demoMode) {
                        setUserBalance(b => b + droppedPrize.value); 
                      }
                      setDroppedPrize(null); 
                      setShowCaseModal(false); 
                    }} style={{padding: '8px 18px', borderRadius: 10, border: '2px solid #4fa3f7', background: 'transparent', color: '#fff', fontWeight: 700, fontSize: '1em', cursor: 'pointer', boxShadow: '0 0 8px #1ed76055'}}>
                      {demoMode ? 'Продать (демо)' : <>Продать за {droppedPrize.value} {GemIcon}</>}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
      {showTopup && (
        <div style={{position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.55)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <div style={{background: '#23242a', borderRadius: 16, padding: 24, minWidth: 280, boxShadow: '0 4px 24px rgba(0,0,0,0.18)', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <div style={{fontWeight: 700, fontSize: '1.1em', marginBottom: 12}}>Купить gems</div>
            <div style={{marginBottom: 12}}>
              <button onClick={() => setTopupAmount('10')} style={{margin: 2, padding: '6px 14px', borderRadius: 8, border: 'none', background: topupAmount==='10'?'#4fa3f7':'#181a20', color: '#fff', fontWeight: 700, cursor: 'pointer'}}>+10</button>
              <button onClick={() => setTopupAmount('50')} style={{margin: 2, padding: '6px 14px', borderRadius: 8, border: 'none', background: topupAmount==='50'?'#4fa3f7':'#181a20', color: '#fff', fontWeight: 700, cursor: 'pointer'}}>+50</button>
              <button onClick={() => setTopupAmount('100')} style={{margin: 2, padding: '6px 14px', borderRadius: 8, border: 'none', background: topupAmount==='100'?'#4fa3f7':'#181a20', color: '#fff', fontWeight: 700, cursor: 'pointer'}}>+100</button>
            </div>
            <input type="number" min={1} value={topupAmount} onChange={e => setTopupAmount(e.target.value.replace(/^0+/, ''))} style={{width: 90, padding: 6, borderRadius: 8, border: '1px solid #4fa3f7', marginBottom: 14, textAlign: 'center', fontSize: '1.1em'}} placeholder="Сумма" />
            <div style={{fontSize: '0.95em', color: '#aaa', marginBottom: 10}}>1 звезда = 1 gem</div>
            <div style={{display: 'flex', gap: 10}}>
              <button 
                disabled={!userId || !topupAmount || isNaN(Number(topupAmount)) || Number(topupAmount) < 1}
                onClick={async () => {
                  const amount = Number(topupAmount);
                  if (!userId || !topupAmount || isNaN(amount) || amount < 1) {
                    alert('Введите сумму и дождитесь загрузки профиля');
                    return;
                  }
                  try {
                    const resp = await fetch('http://localhost:8000/api/buy', {
                      method: 'POST',
                      headers: {'Content-Type': 'application/json'},
                      body: JSON.stringify({user_id: userId, amount})
                    });
                    const data = await resp.json();
                    if (data.success) {
                      setUserBalance(b => b + amount);
                      setShowTopup(false);
                      setTopupAmount('');
                    } else {
                      alert(data.message || 'Ошибка при покупке');
                    }
                  } catch (e) {
                    alert('Ошибка соединения');
                  }
                }}
                style={{padding: '7px 18px', borderRadius: 8, border: 'none', background: (!userId || !topupAmount || isNaN(Number(topupAmount)) || Number(topupAmount) < 1) ? '#888' : '#4fa3f7', color: '#fff', fontWeight: 700, fontSize: '1em', cursor: (!userId || !topupAmount || isNaN(Number(topupAmount)) || Number(topupAmount) < 1) ? 'not-allowed' : 'pointer'}}>
                Купить
              </button>
              <button onClick={() => setShowTopup(false)} style={{padding: '7px 18px', borderRadius: 8, border: 'none', background: '#181a20', color: '#fff', fontWeight: 700, fontSize: '1em', cursor: 'pointer'}}>Отмена</button>
            </div>
          </div>
        </div>
      )}
      {showPromoModal && (
        <div style={{position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.55)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <div style={{background: '#23242a', borderRadius: 16, padding: 24, minWidth: 280, boxShadow: '0 4px 24px rgba(0,0,0,0.18)', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <div style={{fontWeight: 700, fontSize: '1.1em', marginBottom: 12}}>Введите промокод</div>
            <input type="text" value={promoInput} onChange={e => { setPromoInput(e.target.value); setPromoError(""); }} style={{width: 160, padding: 8, borderRadius: 8, border: '1.5px solid #a259ff', marginBottom: 10, textAlign: 'center', fontSize: '1.1em'}} placeholder="Промокод" />
            {promoError && <div style={{color: '#ff6f61', marginBottom: 8, fontWeight: 600}}>{promoError}</div>}
            <div style={{display: 'flex', gap: 10}}>
              <button onClick={handlePromo} style={{padding: '7px 18px', borderRadius: 8, border: 'none', background: '#a259ff', color: '#fff', fontWeight: 700, fontSize: '1em', cursor: 'pointer'}}>Активировать</button>
              <button onClick={() => { setShowPromoModal(false); setPromoInput(""); setPromoError(""); }} style={{padding: '7px 18px', borderRadius: 8, border: 'none', background: '#181a20', color: '#fff', fontWeight: 700, fontSize: '1em', cursor: 'pointer'}}>Отмена</button>
            </div>
          </div>
        </div>
      )}
      {showLoadingModal && (
        <div style={{position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.55)', zIndex: 10001, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <div style={{background: '#23242a', borderRadius: 16, padding: 32, minWidth: 180, boxShadow: '0 4px 24px rgba(0,0,0,0.18)', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <div style={{fontWeight: 700, fontSize: '1.1em', color: '#a259ff', marginBottom: 8}}>{loadingText || 'Загрузка...'}</div>
            <div className="loader" style={{width: 36, height: 36, border: '4px solid #a259ff', borderTop: '4px solid #23242a', borderRadius: '50%', animation: 'spin 1s linear infinite'}} />
          </div>
          <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
        </div>
      )}
      {showWithdrawModal && withdrawGift && (
        <div className="tg-modal-bg" style={{position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.55)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center'}} onClick={() => setShowWithdrawModal(false)}>
          <div className="tg-modal-prize" style={{background: '#23242a', borderRadius: 18, padding: 32, minWidth: 280, boxShadow: '0 4px 24px rgba(0,0,0,0.18)', display: 'flex', flexDirection: 'column', alignItems: 'center'}} onClick={e => e.stopPropagation()}>
            <div style={{fontSize: 44, marginBottom: 10}}>{withdrawGift.icon}</div>
            <div style={{fontWeight: 700, fontSize: '1.1em', color: '#fff', marginBottom: 12, textAlign: 'center', wordBreak: 'break-word', maxWidth: 220}}>{withdrawGift.label}</div>
            {withdrawLoading && (
              <>
                <div style={{margin: '18px 0 0 0', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                  <div className="tg-spinner" style={{width: 38, height: 38, border: '4px solid #a259ff55', borderTop: '4px solid #a259ff', borderRadius: '50%', animation: 'spin 1s linear infinite', marginBottom: 16}} />
                  <div style={{color: '#aaa', fontWeight: 600, fontSize: '1.05em'}}>Создание заявки...</div>
                </div>
              </>
            )}
            {withdrawDone && (
              <>
                <div style={{fontWeight: 800, fontSize: '1.2em', color: '#4fa3f7', margin: '18px 0 10px 0'}}>Заявка на вывод отправлена!</div>
                <button onClick={() => setShowWithdrawModal(false)} style={{marginTop: 8, padding: '8px 28px', borderRadius: 12, border: 'none', background: '#a259ff', color: '#fff', fontWeight: 700, fontSize: '1.1em', cursor: 'pointer', boxShadow: '0 0 8px #a259ff55'}}>Ок</button>
              </>
            )}
          </div>
          <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% {transform: rotate(360deg);} }`}</style>
        </div>
      )}
      <style>{`
        .tg-bottom-nav .tg-nav-item {
          outline: none !important;
          box-shadow: none;
          border-radius: 12px;
          transition: background 0.6s cubic-bezier(.4,2,.6,1), box-shadow 0.25s, border 0.6s cubic-bezier(.4,2,.6,1);
          background: transparent;
          border: none;
        }
        .tg-bottom-nav .tg-nav-item.active {
          background: #a259ff;
          box-shadow: 0 0 0 2.5px #a259ff;
          border-radius: 12px;
          border: 2px solid #a259ff;
          transition: background 0.6s cubic-bezier(.4,2,.6,1), border 0.6s cubic-bezier(.4,2,.6,1);
        }
        .tg-bottom-nav .tg-nav-item.active:not(:active) {
          background: #23242a;
          transition: background 0.6s cubic-bezier(.4,2,.6,1), border 0.6s cubic-bezier(.4,2,.6,1);
        }
        .tg-bottom-nav .tg-nav-item:active {
          background: #a259ff;
          transition: background 0.12s;
        }
        button, input, select, textarea, [role="button"], div[tabindex] {
          outline: none !important;
          box-shadow: none !important;
        }
        button:focus, button:active,
        input:focus, input:active,
        select:focus, select:active,
        textarea:focus, textarea:active,
        [role="button"]:focus, [role="button"]:active,
        div[tabindex]:focus, div[tabindex]:active {
          outline: none !important;
          box-shadow: none !important;
        }
        .tg-case-card:focus, .tg-case-card:active {
          outline: none !important;
          box-shadow: none !important;
        }
        @keyframes spin-rotate {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .tg-tabs {
          display: flex;
          gap: 12px;
          margin: 18px 0 0 0;
          justify-content: center;
        }
        .tg-tab {
          padding: 8px 28px;
          border-radius: 16px;
          font-weight: 700;
          font-size: 1.1em;
          background: #31343b;
          color: #1ed760;
          border: none;
          cursor: pointer;
          transition: background 0.6s cubic-bezier(.4,2,.6,1), border 0.4s cubic-bezier(.4,2,.6,1);
        }
        .tg-tab.active {
          background: #292a30;
          color: #1ed760;
          border: 2px solid #a259ff;
        }
        .tg-tab:active {
          background: #a259ff;
          transition: background 0.12s;
        }
      `}</style>
    </div>
  );
};

export default MiniAppMain; 